<template>
  <div class="card card-contracts">
    <div class="card-header">{{ $t("contracts") }}</div>
    <div class="card-body p-5">
      <!--      <Loading class="mt-2 mb-2" v-if="loading" />-->
      <div class="row" v-if="items">
        <div class="col-12 col-md-6">
          <div>
            <a
              class="color-white"
              href="https://www.haberl.sk/wp-content/uploads/2023/06/Predzmluvne-informacie-072020.pdf"
              target="_blank"
            >
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("precontract_information") }}
            </a>
            <br />
          </div>

          <div>
            <a
              class="color-white"
              href="https://www.haberl.sk/wp-content/uploads/2023/06/VOP-072020.pdf"
              target="_blank"
            >
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("terms_and_conditions") }}
            </a>
            <br />
          </div>

          <div v-if="items.includes('investmentQuestionnaire')">
            <a class="color-white" @click="download('investmentQuestionnaire')">
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("investment_questionnaire") }}
            </a>
            <br />
          </div>

          <div v-if="items.includes('commissionContract')">
            <a class="color-white" @click="download('commissionContract')">
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("commission_contract") }}
            </a>
            <br />
          </div>

          <div v-if="items.includes('portfolioManagementContract')">
            <a
              class="color-white"
              @click="download('portfolioManagementContract')"
            >
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("portfolio_management_contract") }}
            </a>
            <br />
          </div>

          <div v-if="items.includes('strategy')">
            <a class="color-white" @click="download('strategy')">
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("strategy_proposal") }}
            </a>
            <br />
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div v-if="items.includes('category')">
            <a class="color-white" @click="download('category')">
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("category_announcement") }}
            </a>
            <br />
          </div>

          <div v-if="items.includes('riskProfile')">
            <a class="color-white" @click="download('riskProfile')">
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("risk_profile_announcement") }}
            </a>
            <br />
          </div>

          <div>
            <a
              class="color-white"
              href="https://www.haberl.sk/wp-content/uploads/2023/07/HWM-sadzobnik-poplatkov-2023.pdf"
              target="_blank"
            >
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("tariff") }}
            </a>
            <br />
          </div>

          <div>
            <a
              class="color-white"
              href="https://www.haberl.sk/wp-content/uploads/2023/06/Platobne-instrukcie.pdf"
              target="_blank"
            >
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("payment_instructions") }}
            </a>
            <br />
          </div>
        </div>
      </div>

      <div class="row mt-5" v-if="items.includes('contractSFA')">
        <div class="col-12">
          <div v-if="items.includes('contractSFA')">
            <a class="color-white" @click="download('contractSFA')">
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("contract_sfa") }}
            </a>
            <br />
          </div>

          <div v-if="items.includes('tariffSFA')">
            <a class="color-white" @click="download('tariffSFA')">
              <font-awesome-icon :icon="fileIcon" class="mr-2" />
              {{ $t("tariff_sfa") }}
            </a>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../../../components/Loading";
import contracts from "@/store/modules/contracts";

export default {
  name: "Confirmations",
  components: {
    Loading
  },
  data() {
    return {
      fileIcon: ["fa", "file-pdf"],
      path: ""
    };
  },
  mounted() {
    // if (this.$store.state.account.profileInfo.id !== 1) {
    this.$store.dispatch("contracts/list");
    // }

    this.path = process.env.VUE_APP_API_FILES_LINK;
  },
  computed: {
    items() {
      return this.$store.state.contracts.items;
    }
  },
  methods: {
    download(fileType) {
      this.$store.dispatch("contracts/download", { fileType });
    }
  }
};
</script>

<style lang="scss">
.card-contracts {
  a {
    cursor: pointer;
  }
}
</style>
